import axios from "axios"
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import PlaceholderCard from "examples/Cards/PlaceholderCard";

import ProfileCardSpecial from "examples/ProfileCards/ProfileCardSpecial";
import ProfileCardSpecialIletisim from "examples/ProfileCards/ProfileCardSpecialIletisim";
import ProfileCardSpecialSaglik from "examples/ProfileCards/ProfileCardSpecialSaglik";
import ProfileCardKurum from "examples/ProfileCards/ProfileCardKurum";
import ProfileCardKurumSema from "examples/ProfileCards/ProfileCardKurumSema";
import ProfileCardEgitim from "examples/ProfileCards/ProfileCardEgitim";
import ProfileCardIzinler from "examples/ProfileCards/ProfileCardIzinler";
import ProfileCardTerfi from "examples/ProfileCards/ProfileCardTerfi";
import ProfileCardZimmet from "examples/ProfileCards/ProfileCardZimmet";
import ProfileCardZimmetBack from "examples/ProfileCards/ProfileCardZimmetBack";
import ProfileCardNot from "examples/ProfileCards/ProfileCardNot";
import ProfileCardDosya from "examples/ProfileCards/ProfileCardDosya";
import ProfileCardDisiplin from "examples/ProfileCards/ProfileCardDisiplin";
import ProfileCardDisiplinVerilen from "examples/ProfileCards/ProfileCardDisiplinVerilen";
import ProfileCardPerformans from "examples/ProfileCards/ProfileCardPerformansInews";

import Degerlendirme from "layouts/profile/components/ProfileDetail/degerlendirme-bilgi"
import Disiplin from "layouts/profile/components/ProfileDetail/disiplin-bilgi"
import Egitim from "layouts/profile/components/ProfileDetail/egitim-bilgi"
import Evrak from "layouts/profile/components/ProfileDetail/evrak-dosya"
import Izinler from "layouts/profile/components/ProfileDetail/izinler-bilgi"
import Kisisel from "layouts/profile/components/ProfileDetail/kisisel-bilgi"
import Kurum from "layouts/profile/components/ProfileDetail/kurum-bilgi"
import Ozet from "layouts/profile/components/ProfileDetail/ozet-bilgi"
import Performans from "layouts/profile/components/ProfileDetail/performans-bilgi"
import Zimmet from "layouts/profile/components/ProfileDetail/zimmet-bilgi"

import ProfileCardOzet from "examples/ProfileCards/ProfileCardOzet";

// Overview page components
import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";

// Images
import homeDecor1 from "assets/images/home-decor-1.jpg";
import homeDecor2 from "assets/images/home-decor-2.jpg";
import homeDecor3 from "assets/images/home-decor-3.jpg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { Button } from "@mui/material";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import PermissionNavbarPage from "examples/Navbars/PermissionNavbarPage";
import NoPermission from "layouts/dashboard/components/NoPermission";

function Overview() {
  const [tabIndex, setTabIndex] = useState(0);
  const [data, setData] = useState([]);
  const [dataPer, setDataPer] = useState([]);

  const userId = useSelector(state => state.auth.userId);
  const userKanal = useSelector(state => state.auth.userKanal);

  const { id } = useParams();
  const navigate = useNavigate();

  const onTabChange = (index) => {
    if (tabIndex != -1) {
      setTabIndex(index);
    }
  }

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${window.BASE_URL}/user/${id}?format=json`, { withCredentials: true });
        setData(response.data);
      } catch (error) {
        setData("error");
      }
    };

    fetchUserData();
  }, [id]);

  useEffect(() => {
    const fetchPermissionsData = async () => {
      try {
        const response = await axios.get(`${window.BASE_URL}/permissions?format=json`, { withCredentials: true });
        setDataPer(response.data);
      } catch (error) {
        console.log("Permissions data fetch error");
      }
    };

    fetchPermissionsData();
  }, []);

  // Eğer veri yüklenirken veya hata oluşmuşsa koşullu render
  // if (data === "error") {
  //   return <PermissionNavbarPage />;
  // }

  useEffect(() => {
    if (data?.kanal?.kanal_adi != userKanal && userId == data?.id) {
      setTabIndex(-1);
    }
  }, [data]);

  return (
    <DashboardLayout>
      <Header onChange={onTabChange} data={data} permission={dataPer} />
      <SoftBox mt={5} mb={3}>
        <Grid container spacing={3}>

          {tabIndex === -1 && (
            <Grid item xs={12} md={12} xl={12}>
              <SoftBox pt={3} px={3}>
                <SoftTypography variant="h5" fontWeight="small">
                  <NoPermission title="Kanal Doğrulama" text={"Erişmeye Çalıştığınız Personel Detayları Sadece " + data?.kanal?.kanal_adi + " Kanalında Görüntülenebilir. Menüden Seçili Kanal Ayarlarını Değiştiriniz!"} ></NoPermission>
                </SoftTypography>
              </SoftBox>
            </Grid>
          )}

          {tabIndex === 0 && (

            <Kisisel />
            // <>
            //   <ProfileCardSpecial data={data} />
            //   <ProfileCardSpecialIletisim data={data} />
            //   <ProfileCardSpecialSaglik data={data} />
            // </>
          )}
          {tabIndex === 1 && (
            <Kurum />
            // <>
            //   <ProfileCardKurum data={data} />
            //   <ProfileCardKurumSema data={data} />
            // </>
          )}
          {tabIndex === 2 && (
            <Egitim />
            // <>
            //   <ProfileCardEgitim data={data} />
            // </>
          )}
          {tabIndex === 3 && (
            <Ozet />
            // <>
            //   <ProfileCardOzet data={data} />
            // </>
          )}
          {tabIndex === 4 && (
            <Izinler />
            // <>
            //   <ProfileCardIzinler data={data} />
            // </>
          )}
          {tabIndex === 5 && (
            <Zimmet />
            // <>
            //   <ProfileCardZimmetBack data={data} />
            //   <ProfileCardZimmet data={data} />
            // </>
          )}
          {tabIndex === 6 && (
            <Performans />
            // <>
            //   <ProfileCardPerformans data={data} />
            // </>
          )}
          {tabIndex === 7 && (
            <Disiplin />
            // <>
            //   <ProfileCardDisiplin data={data} />
            //   <ProfileCardDisiplinVerilen data={data} />
            // </>
          )}
          {tabIndex === 8 && (
            <Degerlendirme />
            // <>
            //   <ProfileCardNot data={data} />
            // </>
          )}
          {tabIndex === 9 && (
            <Evrak />
            // <>
            //   <ProfileCardDosya data={data} />
            // </>
          )}

        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
